module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Inappropriate")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Hide",
      "value": "hide"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Show",
      "value": "show"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Only",
      "value": "only"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7d202d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/InappropriateFilter.vue
// module id = 1054
// module chunks = 1